import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on(
    'click',
    '.h-s-button--create-tracked-time-category, .h-s-button--export-tracked-times-csv',
    (e) => {
      $(e.currentTarget).blur();
    }
  );
});
